import { useField } from '../../lib/hooks/useField'
import { FormComponentConstructor } from '../../lib/types'
import { Toggle } from '../../../Toggle/Toggle'
import { FieldDescription } from '../FieldDescription/FieldDescription'

export const createCheckboxField: FormComponentConstructor<any> = ({
    field,
}) => {
    return ({ name, label, misc }) => {
        const { value, setValue } = useField(field)

        return (
            <>
                <Toggle
                    name={name}
                    label={label}
                    onChange={(value) => {
                        if (value) {
                            setValue('yes')
                        } else {
                            setValue('')
                        }
                    }}
                    value={value === 'yes'}
                />
                {misc?.description && (
                    <FieldDescription description={misc.description} />
                )}
            </>
        )
    }
}
